import About from "../pages/about/About";
import Dashboard from "../pages/Dashboard/Dashboard";
import Home from "../pages/home/Home";
import {
  LayoutGrid,
  House,
  LandPlot,
  Users,
  FlagTriangleRight,
  Lamp,
  Images,
  BookUser,
  Feather,
  Settings,
} from "lucide-react";


import Service from "../pages/service/Service";
import ServiceDetail from "../pages/service/detail/ServiceDetail";


import Gallery from "../pages/gallery/Gallery";
import Contact from "../pages/contact/Contact";
import AuthorBlogPage from "../pages/blog/AuthorBlog";

export interface AppRoute {
  key: string;
  label: string;
  url?: string;
  icon?: React.ComponentType<any>;
  component?: React.ComponentType;
  children?: AppRoute[];
  hidden?: boolean;
  ignore?: number;
}

const routes: AppRoute[] = [
  // {
  //   key: "1",
  //   label: "Dashboard",
  //   url: "/",
  //   icon: LayoutGrid,
  //   component: Dashboard,
  // },
  {
    key: "2",
    label: "Home",
    url: "/",
    icon: House,
    component: Home,
  },
  {
    key: "3",
    label: "About Us",
    url: "/about",
    icon: LandPlot,
    component: About,
  },

  {
    key: "5",
    label: "Service",
    url: "/service",
    icon: FlagTriangleRight,
    children: [
      {
        key: "5-1",
        label: "Service Listing",
        url: "/",
        component: Service,
      },
      {
        key: "5-2",
        label: "Service Detail",
        url: "/detail",
        component: ServiceDetail,
        hidden: true,
      },
    ],
  },

  {
    key: "7",
    label: "Gallery",
    url: "/gallery",
    icon: Images,
    component: Gallery,
  },
  {
    key: "8",
    label: "Contact Us",
    url: "/contact",
    icon: BookUser,
    component: Contact,
  },
  {
    key: "9",
    label: "Blogs",
    url: "/blogs",
    icon: Feather,
    component: AuthorBlogPage,
  },
];

export default routes;
